// importarlibrerias
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
//importar store
import store from '../store/index.js';

//funcion para recorrer las rutas y crear arreglo
function route (path, folder, view, name, meta, children) {
  //debugger;
  return {
    name: name || '',
    path,
    meta,
    component: (resolve) => import(
      `@/${folder}/${view}.vue`
    ).then(resolve), 
    children: children || []
  }
}

// importar rutas // rutas de account
import account from './paths_account' 
import dimenu from './paths_dimenu' 
import display from './paths_display'

//recorrer rutasimportadas
let rutas_account= account.map(r => route(r.path, r.folder, r.view, r.name, r.meta, r.children));
let rutas_dimenu = dimenu.map(r => route(r.path, r.folder, r.view, r.name, r.meta, r.children));
let rutas_display = display.map(r => route(r.path, r.folder, r.view, r.name, r.meta, r.children));
//unificar rutas en un arreglo
let rutas = []; // arreglo global
rutas=rutas.concat(rutas_account);
rutas=rutas.concat(rutas_dimenu);
rutas=rutas.concat(rutas_display);
rutas=rutas.concat([{ path: '*',redirect: '/' }]);
//console.log('rutas creadas')
//console.log(rutas)

Vue.use(Router)

// creando router
const router = new Router({
  mode: 'history',
  routes: rutas,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
router.beforeEach((to, from, next) => {
  //debugger;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'Login',
      })
    } else {
      //console.log('enviando desde router 1')
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      //console.log('enviando desde router 2')
      next({
        name: 'Home',
      })
    } else {
      //console.log('enviando desde router 3')
      next()
    }
  } else {
    //console.log('enviando desde router 4')
    next()
  }
})

export default router;